import { BaseEventBuilder } from '@droidmap/shared-service-contract'

import { Folder } from '../models/folder.js'
import { Project } from '../models/project.js'

const serviceSource = 'droidmap.backend.project-service'

export const ProjectCreated = new BaseEventBuilder<Project, 'Project Created'>(
  serviceSource,
  'Project Created',
)

export const ProjectDeleted = new BaseEventBuilder<Project, 'Project Deleted'>(
  serviceSource,
  'Project Deleted',
)

export const ProjectUpdated = new BaseEventBuilder<Project, 'Project Updated'>(
  serviceSource,
  'Project Updated',
)

export const FolderCreated = new BaseEventBuilder<Folder, 'Folder Created'>(
  serviceSource,
  'Folder Created',
)

export const FolderDeleted = new BaseEventBuilder<Folder, 'Folder Deleted'>(
  serviceSource,
  'Folder Deleted',
)

/** Emitted on rename and on move (move carries a changed `parentFolderId`). */
export const FolderUpdated = new BaseEventBuilder<Folder, 'Folder Updated'>(
  serviceSource,
  'Folder Updated',
)
